// Module
var code = "<el-row type=\"flex\" justify=\"space-between\" align=\"middle\" class=\"user-suggest__item\"> <span> {{user.last_name}} {{user.first_name}} {{user.phone}} </span> <el-button @click=\"chooseUser\" type=\"primary\" size=\"medium\">Выбрать</el-button> </el-row> ";
// Exports
module.exports = code;